/**
 * HeroBannerTS: Banner promocional grande arriba de la Guía TS+.
 * Configurable con props para futura conexión con backend/admin.
 * Formato: fondo con gradient/imagen + texto grande + CTA + ilustración lateral.
 */
import React from 'react';
import { Sparkles, ArrowRight, Gift } from 'lucide-react';
import { Button } from '../ui/button';

export default function HeroBannerTS({
  eyebrow = '¡Llegó TS+!',
  titulo = 'Beneficios exclusivos para vos',
  subtitulo = 'Descuentos, cupones y promociones para colegas del Colegio de Trabajadores Sociales de Lomas de Zamora',
  ctaLabel = 'Ver todos los beneficios',
  onCta,
  onClick,
}) {
  return (
    <section
      className="relative overflow-hidden rounded-3xl shadow-lg mb-6 cursor-pointer"
      onClick={onClick || onCta}
      data-testid="hero-banner"
    >
      {/* Fondo con gradient + patrón sutil */}
      <div className="absolute inset-0 bg-gradient-to-br from-purple-600 via-purple-700 to-indigo-800" />
      {/* Círculos decorativos */}
      <div className="absolute -top-16 -right-16 w-64 h-64 rounded-full bg-white/10 blur-2xl" />
      <div className="absolute -bottom-20 -left-10 w-56 h-56 rounded-full bg-fuchsia-400/20 blur-2xl" />

      <div className="relative grid grid-cols-1 md:grid-cols-5 gap-6 p-6 sm:p-8 md:p-10 min-h-[220px] sm:min-h-[280px]">
        {/* Texto */}
        <div className="md:col-span-3 flex flex-col justify-center text-white">
          <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm rounded-full px-3 py-1 w-fit mb-3">
            <Sparkles className="w-3.5 h-3.5" />
            <span className="text-xs font-semibold uppercase tracking-wider">{eyebrow}</span>
          </div>
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold leading-tight mb-2 drop-shadow-md">
            {titulo}
          </h1>
          <p className="text-sm sm:text-base text-white/90 leading-relaxed mb-4 max-w-lg">
            {subtitulo}
          </p>
          {ctaLabel && (
            <Button
              onClick={(e) => {
                e.stopPropagation();
                if (onCta) onCta();
              }}
              className="w-fit bg-white text-purple-800 hover:bg-purple-50 font-semibold shadow-md"
              data-testid="hero-banner-cta"
            >
              {ctaLabel}
              <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          )}
        </div>

        {/* Ilustración lateral (icono grande) */}
        <div className="hidden md:flex md:col-span-2 items-center justify-end">
          <div className="relative">
            <div className="absolute inset-0 bg-white/20 rounded-full blur-2xl" />
            <div className="relative w-32 h-32 lg:w-40 lg:h-40 bg-white/95 rounded-3xl shadow-2xl flex items-center justify-center rotate-6 hover:rotate-0 transition-transform">
              <Gift className="w-16 h-16 lg:w-20 lg:h-20 text-purple-600" />
            </div>
            <div className="absolute -top-4 -right-4 w-12 h-12 bg-amber-400 rounded-2xl shadow-lg flex items-center justify-center -rotate-12">
              <Sparkles className="w-6 h-6 text-amber-900" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
